import { useEffect, useRef } from 'react';
import { useXpSummary } from './useXpSummary';
import { maybeCelebrateXp } from '../helpers/xpCelebrations.helper';

/**
 * Fires the level-up / rank-up celebration when a fetched XP summary shows a higher
 * level than the last celebrated one (specs/xp-and-ranks AC-15). Mounted once via
 * CelebrationHost. Each distinct summary is handled once per session.
 */
export function useXpCelebrations(): void {
  const { data, userId } = useXpSummary();
  const lastHandledRef = useRef<string | null>(null);

  useEffect(() => {
    if (!data || !userId) return;
    const signature = `${userId}:${data.level}:${data.totalXp}`;
    if (lastHandledRef.current === signature) return;
    lastHandledRef.current = signature;
    void maybeCelebrateXp(userId, data);
  }, [data, userId]);
}
